export default "__VITE_ASSET__BxTxxSn3__"